










import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

// Enums
import { EmailTypes } from "@/data/enums/emails";
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${DataModules.EMAILS}/listScope`](this.emailType);
      }
    })
  },
  components: {
    "email-history-table": () =>
      import("@/components/app/global/emailHistory/emailHistoryTable.vue"),
    "emails-history-provider": () =>
      import("@/components/app/global/emailHistory/emailsHistoryProvider.vue")
  }
})
export default class AdminEmailHistory extends Vue {
  // Getters
  public dataScope!: string;

  // Variables
  public emailType = EmailTypes.MYSELF;
}
